if (typeof CartForm !== "function") {
  class CartForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.ajaxifyCartItems();
      this.addComplementaryProductsEventListeners();
      this.setupDiamondUpgrade();
      this.setupCartBundleEventListeners();
      this.setupSubscriptionProductListener();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector("form");
      this.querySelectorAll("[data-js-cart-item]").forEach((item) => {
        const remove = item.querySelector(".remove");
        if (remove) {
          if (remove._removeHandler) {
            remove.removeEventListener("click", remove._removeHandler);
          }
          
          remove.dataset.href = remove.getAttribute("href");
          remove.setAttribute("href", "");
          
          remove._removeHandler = (e) => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          };
          
          remove.addEventListener("click", remove._removeHandler);
        }
        
        const qty = item.querySelector(".qty");
        if (qty) {
          if (qty._qtyHandler) {
            qty.removeEventListener("input", qty._qtyHandler);
          }
          if (qty._clickHandler) {
            qty.removeEventListener("click", qty._clickHandler);
          }
          
          qty._qtyHandler = debounce((e) => {
            e.preventDefault();
            e.target.blur();
            this.updateCartQty(item, parseInt(qty.value));
          }, 500);
          
          qty._clickHandler = (e) => {
            e.target.select();
          };
          
          qty.addEventListener("input", qty._qtyHandler);
          qty.addEventListener("click", qty._clickHandler);
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;
      const bundleInstanceId = item.dataset.bundleInstanceId;
      const itemKey = item.dataset.key;
      const isSubscriptionProduct = item.dataset.isMainProduct === 'true' && 
        item.closest('.cart_bundle')?.classList.contains('not-a-frame');
          
      this.form.classList.add("processing");
      if (this.querySelector(".alert")) {
        this.querySelector(".alert").remove();
      }
      const updates = {};
      if (newQty === 0) {
        const bundleContainer = item.closest('.cart_bundle');
        if (bundleContainer) {
          bundleContainer.querySelectorAll('[data-js-cart-item]').forEach((cartItem) => {
            const key = cartItem.dataset.key;
            if (key) {
              updates[key] = 0;
            }
          });
        } else {
          updates[itemKey] = 0;
        }
      } else {
        const parent = item.closest(".cart_bundle");
        if (parent) {
          parent.querySelectorAll(".cart-item").forEach((cartItem) => {
            const key = cartItem.dataset.key;
            if (key) {
              updates[key] = newQty;
            }
          });
        } else {
          const key = item.dataset.key;
          if (key) {
            updates[key] = newQty;
          }
        }
      }
      const body = JSON.stringify({ updates: updates });
      fetch(KROWN.settings.routes.cart_update_url || "/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript",
        },
        body,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status == 422) {
            alert = document.createElement("span");
            alert.classList.add("alert", "alert--error");
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }
          return this.renderCartDrawer();
        })
        .then(() => {
          if (isSubscriptionProduct && newQty === 0) {
            const subscriptionProductPage = document.querySelector('.product-page .subscription-product');
            const subscriptionProductSidebar = document.querySelector('#site-cart-sidebar .subscription-product');
            
            if (subscriptionProductPage) {
              subscriptionProductPage.classList.remove('display-none');
              subscriptionProductPage.classList.remove('hidden');
            }
            
            if (subscriptionProductSidebar) {
              subscriptionProductSidebar.classList.remove('display-none');
              subscriptionProductSidebar.classList.remove('hidden');
            }
          }
          
          if (newQty === 0) {
            const cartItems = document.getElementById('AjaxCartForm');
            if (cartItems) {
              const remainingItems = cartItems.querySelectorAll('.primary-item, [data-is-main-product="true"]');
              if (remainingItems.length === 0) {
                const sidebar = document.getElementById('site-cart-sidebar');
                if (sidebar && !sidebar.classList.contains('cart-is-empty')) {
                  sidebar.classList.add('cart-is-empty');
                }
                
                return this.renderCartDrawer();
              }
            }
          }
        })
        .catch((e) => {
          alert = document.createElement("span");
          alert.classList.add("alert", "alert--error");
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
          this.form.classList.remove("processing");
        });
    }

    renderCartDrawer() {
      return fetch("?section_id=sidebar-drawer")
        .then((response) => response.text())
        .then((text) => {
          const sectionHTML = new DOMParser().parseFromString(
            text,
            "text/html"
          );
          
          const primaryItems = sectionHTML.querySelectorAll('.primary-item');
          
          const validPrimaryItems = Array.from(primaryItems).filter(item => {
            return item.dataset.notAFrame !== 'true';
          });
          
          const sidebar = document.getElementById('site-cart-sidebar');
          if (validPrimaryItems.length === 1) {
            sidebar.classList.add('fifty-percent-discount');
          } else {
            sidebar.classList.remove('fifty-percent-discount');
          }
          
          const cartFormInnerHTML =
            sectionHTML.getElementById("AjaxCartForm").innerHTML;
          const cartSubtotalInnerHTML =
            sectionHTML.getElementById("AjaxCartSubtotal").innerHTML;

          const cartItems = document.getElementById("AjaxCartForm");
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();
          cartItems.setupCartBundleEventListeners();
          cartItems.setupSubscriptionProductListener();

          const mainProductCount = cartItems.querySelectorAll('.primary-item, [data-is-main-product="true"]').length;
          document
            .querySelectorAll("[data-header-cart-count]")
            .forEach((elm) => {
              elm.textContent = mainProductCount;
            });
          document
            .querySelectorAll("[data-header-cart-total]")
            .forEach((elm) => {
              elm.textContent =
                cartItems.querySelector("[data-cart-total]").textContent;
            });
          document.getElementById("AjaxCartSubtotal").innerHTML =
            cartSubtotalInnerHTML;
          
          const subscriptionProductNew = sectionHTML.querySelector('#site-cart-sidebar .subscription-product');
          const subscriptionProductCurrent = document.querySelector('#site-cart-sidebar .subscription-product');
          
          if (subscriptionProductNew && subscriptionProductCurrent) {
            try {
              subscriptionProductCurrent.outerHTML = subscriptionProductNew.outerHTML;
            } catch (error) {
              
            }
          } else if (subscriptionProductNew && !subscriptionProductCurrent) {
            try {
              const cartBody = document.querySelector('#site-cart-sidebar .sidebar__body');
              if (cartBody) {
                cartBody.appendChild(subscriptionProductNew.cloneNode(true));
              }
            } catch (error) {
              
            }
          } else if (!subscriptionProductNew && subscriptionProductCurrent) {
            try {
              subscriptionProductCurrent.remove();
            } catch (error) {
              
            }
          }
          
          this.dispatchEvent(new Event("cart-updated"));
          
          if (typeof window.addEventListeners === 'function') {
            window.addEventListeners();
          }
          
          if (typeof window.setupSubscriptionEventListeners === 'function') {
            window.setupSubscriptionEventListeners();
          }
        });
    }

    addComplementaryProductsEventListeners() {
      const attachHandlers = () => {
        document
          .querySelectorAll(".complementary-products .add-button")
          .forEach((button) => {
            button.removeEventListener("click", this._addToCartHandler);

            this._addToCartHandler = () => {
              this.addToCart(button);
            };
            button.addEventListener("click", this._addToCartHandler);
          });
      };
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.target.matches(".complementary-products") ||
            Array.from(mutation.addedNodes).some(
              (node) => node.matches && node.matches(".complementary-products")
            )
          ) {
            attachHandlers();
            break;
          }
        }
      });
      observer.observe(this, {
        childList: true,
        subtree: true,
      });
      attachHandlers();
    }

    addToCart(button) {
      const input = button.nextElementSibling;
      if (input && input.tagName.toLowerCase() === "input") {
        const variantId = input.value;
        const uniqueBundleInstanceId =
          Date.now().toString() + Math.random().toString(36).substring(2, 8);
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              _is_main_product: "true",
              _bundle_instance_id: uniqueBundleInstanceId,
            },
          }),
        })
          .then((response) => response.json())
          .then(() => {
            this.renderCartDrawer();
          })
          .catch((e) => e);
      }
    }

    setupDiamondUpgrade() {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1 && node.matches(".upgrade-diamond")) {
                this.attachDiamondUpgradeListener(node);
              } else if (
                node.nodeType === 1 &&
                node.querySelector(".upgrade-diamond")
              ) {
                node
                  .querySelectorAll(".upgrade-diamond")
                  .forEach((checkbox) => {
                    this.attachDiamondUpgradeListener(checkbox);
                  });
              }
            });
          }
        }
      });
      this.observer = observer;
      observer.observe(this, {
        childList: true,
        subtree: true,
      });
      this.querySelectorAll(".upgrade-diamond").forEach((checkbox) => {
        this.attachDiamondUpgradeListener(checkbox);
      });
    }

    setupCartBundleEventListeners() {
      if (this._bundleClickHandler) return;
      this._bundleClickHandler = (event) => {
        const title = event.target.closest('.cart-bundle-title');
        if (!title || !this.contains(title)) return;
        event.preventDefault();
        const bundle = title.closest('.cart_bundle');
        const opening = !bundle.classList.contains('active');
        this.querySelectorAll('.cart_bundle:not(.not-a-frame)').forEach((other) => {
          const expanded = other === bundle && opening;
          other.classList.toggle('active', expanded);
          other.querySelector('.cart-bundle-title')?.setAttribute('aria-expanded', String(expanded));
        });
      };
      this.addEventListener('click', this._bundleClickHandler);
    }

    setupSubscriptionProductListener() {
      const addSubscriptionToCart = (element) => {
        const subscriptionVariantId = element.dataset.variantId;
        const subscriptionSellingPlanId = element.dataset.sellingPlanId;
        const subscriptionPrice = element.dataset.subscriptionPrice || '';
        const subscriptionCompareAtPrice = element.dataset.subscriptionCompareAtPrice || '';
        const subscriptionProductElement = element.closest('.subscription-product');
        const subscriptionProductType = subscriptionProductElement ? (subscriptionProductElement.dataset.subscriptionProductType || subscriptionProductElement.dataset.currentProductType || '') : '';
        const subtotalText = subscriptionProductElement ? subscriptionProductElement.dataset.subtotalSubscriptionProductsText || '' : '';
        
        if (!subscriptionVariantId || 
            subscriptionVariantId.trim() === '' || 
            subscriptionVariantId === 'undefined' ||
            subscriptionVariantId === 'null') {
          return;
        }
        
        if (element.classList.contains('loading')) {
          return;
        }
        
        element.classList.add('loading');
        
        fetch('/cart.js')
          .then(res => res.json())
          .then(currentCart => {
            const existingSubscriptionProduct = currentCart.items.find(item => 
              item.properties && item.properties._not_a_frame === 'true'
            );
            
            if (existingSubscriptionProduct) {
              const updates = {};
              updates[existingSubscriptionProduct.key] = 0;
              
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
              }).then(res => res.json());
            }
            
            return Promise.resolve();
          })
          .then(() => {
            const subscriptionProduct = {
              id: subscriptionVariantId,
              quantity: 1,
              properties: {
                _is_main_product: true,
                _not_a_frame: true,
                _product_total_price: subscriptionPrice,
                _product_total_compare_at_price: subscriptionCompareAtPrice,
                _subtotal_text: subtotalText,
                _subscription_product_type: subscriptionProductType,
              }
            };

            if (subscriptionSellingPlanId) {
              subscriptionProduct.selling_plan = subscriptionSellingPlanId;
            }

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: [subscriptionProduct] })
            });
          })
          .then(response => response.json())
          .then(() => {
            return this.renderCartDrawer();
          })
          .then(() => {
            const subscriptionProductPage = document.querySelector('.product-page .subscription-product');
            const subscriptionProductSidebar = document.querySelector('#site-cart-sidebar .subscription-product');
            
            if (subscriptionProductPage && !subscriptionProductPage.classList.contains('hidden')) {
              subscriptionProductPage.classList.add('hidden');
            }

            if (subscriptionProductSidebar && !subscriptionProductSidebar.classList.contains('hidden')) {
              subscriptionProductSidebar.classList.add('hidden');
            }
            
            element.classList.remove('loading');
          })
          .catch(e => {
            element.classList.remove('loading');
          });
      };

      const attachSubscriptionHandlers = () => {
        const cartSidebar = document.querySelector('#site-cart-sidebar');
        if (!cartSidebar) {
          return;
        }

        const subscriptionProduct = cartSidebar.querySelector('.subscription-product');
        if (!subscriptionProduct) {
          return;
        }

        const subscriptionButtons = subscriptionProduct.querySelectorAll('.subscription-product-button');
        if (subscriptionButtons.length === 0) {
          return;
        }

        subscriptionButtons.forEach((button) => {
          if (!button.dataset.variantId || 
              button.dataset.variantId.trim() === '' || 
              button.dataset.variantId === 'undefined' ||
              button.dataset.variantId === 'null') {
            return;
          }
          
          button.removeEventListener('click', this._subscriptionButtonHandler);
          
          this._subscriptionButtonHandler = (event) => {
            event.preventDefault();
            addSubscriptionToCart(event.currentTarget);
          };
          
          button.addEventListener('click', this._subscriptionButtonHandler);
        });
      };

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes);
            if (addedNodes.some(node => 
              node.nodeType === 1 && 
              (node.querySelector && node.querySelector('#site-cart-sidebar .subscription-product-button') || 
               node.classList?.contains('subscription-product-button'))
            )) {
              attachSubscriptionHandlers();
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      attachSubscriptionHandlers();
    }

    async attachDiamondUpgradeListener(diamondUpgradeCheckbox) {
      diamondUpgradeCheckbox.addEventListener("change", async () => {
        const bundleId = diamondUpgradeCheckbox.dataset.bundleInstanceId;
        let bundleItems = this.getBundleItems(bundleId);
        const itemKeys = this.getItemKeys(bundleItems);
        await this.removePreviousVariants(itemKeys);
        
        await this.updateVariantsAndAddMainProduct(bundleItems, diamondUpgradeCheckbox);
        await this.updateProductIdsAndUpgrade(bundleItems, bundleId);
        await this.renderCartDrawer();
      });
    }

    getBundleItems(bundleId) {
      return Array.from(
        document.querySelectorAll(
          `[data-bundle-instance-id="${bundleId}"].cart-item`
        )
      );
    }

    getItemKeys(bundleItems) {
      return Array.from(bundleItems).map((item) =>
        item.getAttribute("data-key")
      );
    }

    async updateProductIdsAndUpgrade(bundleItems, bundleId) {
      let upgradeElement = document.querySelector(`[data-bundle-instance-id="${bundleId}"].upgrade-diamond`);
      
      if (upgradeElement) {
        const diamondId = upgradeElement.getAttribute(
          "data-diamond-product-id"
        );
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items: [
              {
                id: diamondId,
                quantity: 1,
                properties: {
                  _bundle_instance_id: bundleId,
                },
              },
            ],
          }),
        });
      }
    }

    async removePreviousVariants(itemKeys) {
      const updates = {};
      itemKeys.forEach((key) => {
        updates[key] = 0;
      });
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates }),
      });
      return await res.json();
    }

    async updateVariantsAndAddMainProduct(bundleItems, upgradeElement) {
      let silverId = null;
      let goldId = null;
      
      if (!upgradeElement && bundleItems.length > 0) {
        const bundleId = bundleItems[0].getAttribute("data-bundle-instance-id");
        upgradeElement = document.querySelector(`[data-bundle-instance-id="${bundleId}"].upgrade-diamond`);
      }
      
      if (upgradeElement) {
        silverId = upgradeElement.getAttribute("data-silver-product-id");
        goldId = upgradeElement.getAttribute("data-gold-product-id");
      }

      const currentCoatingItem = bundleItems.find(item => {
        const productId = item.getAttribute("data-product-id");
        return productId === silverId || productId === goldId;
      });
      
      const currentCoatingId = currentCoatingItem ? currentCoatingItem.getAttribute("data-product-id") : null;

      bundleItems = Array.from(bundleItems).filter((item) => {
        const variantId = item.getAttribute("data-product-id");
        return !(variantId === silverId || variantId === goldId);
      });

      const variants = [];
      let mainVariantId = null;
      
      let priceDifference = 0;
      let compareAtDifference = 0;
      
      if (currentCoatingId && upgradeElement) {
        const currentPrice = currentCoatingId === silverId 
          ? parseInt(upgradeElement.getAttribute("data-silver-price")) 
          : parseInt(upgradeElement.getAttribute("data-gold-price"));
        const currentCompareAt = currentCoatingId === silverId 
          ? parseInt(upgradeElement.getAttribute("data-silver-compare-at-price")) 
          : parseInt(upgradeElement.getAttribute("data-gold-compare-at-price"));
        
        const diamondPrice = parseInt(upgradeElement.getAttribute("data-diamond-price"));
        const diamondCompareAt = parseInt(upgradeElement.getAttribute("data-diamond-compare-at-price"));
        
        priceDifference = diamondPrice - currentPrice;
        compareAtDifference = diamondCompareAt - currentCompareAt;
      }
      
      Array.from(bundleItems).forEach((item) => {
        const isMain = item.classList.contains("primary-item");
        let properties = {
          ...(isMain
            ? { _is_main_product: "true" }
            : { _is_main_product: "false" }),
          _bundle_instance_id: item.getAttribute("data-bundle-instance-id"),
        };
        if (isMain) {
          mainVariantId = item.getAttribute("data-id");
          const propsDiv = item.querySelector(".properties-data");
          if (propsDiv) {
            try {
              const arrProps = JSON.parse(propsDiv.textContent);
              const propsObj = {};
              arrProps.forEach(([key, value]) => {
                propsObj[key] = value;
              });
              properties = { ...properties, ...propsObj };
            } catch (e) {}
          }
          
          if (priceDifference !== 0) {
            const currentTotalPrice = properties._product_total_price ? 
              parseInt(properties._product_total_price) : 0;
            const currentTotalCompareAt = properties._product_total_compare_at_price ? 
              parseInt(properties._product_total_compare_at_price) : 0;
            
            const newTotalPrice = currentTotalPrice + priceDifference;
            const newTotalCompareAt = currentTotalCompareAt + compareAtDifference;
            
            properties._product_total_price = newTotalPrice;
            properties._product_total_compare_at_price = newTotalCompareAt;
          }
          
          properties._upgrade_coating = false;
          variants.unshift({
            id: mainVariantId,
            quantity: 1,
            properties: properties,
          });
        } else {
          variants.push({
            id: item.getAttribute("data-id"),
            quantity: 1,
            properties: properties,
          });
        }
      });
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items: variants }),
      });
    }
  }

  if (typeof customElements.get("cart-form") == "undefined") {
    customElements.define("cart-form", CartForm);
  }
}

if (typeof CartProductQuantity !== "function") {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector(".qty-minus").addEventListener(
        "click",
        this.changeCartInput.bind(this)
      );
      this.querySelector(".qty-plus").addEventListener(
        "click",
        this.changeCartInput.bind(this)
      );
    }
    changeCartInput() {
      setTimeout(() => {
        document
          .getElementById("AjaxCartForm")
          .updateCartQty(
            this.closest("[data-js-cart-item]"),
            parseInt(this.querySelector(".qty").value)
          );
      }, 50);
    }
  }

  if (typeof customElements.get("cart-product-quantity") == "undefined") {
    customElements.define("cart-product-quantity", CartProductQuantity);
  }
}

// Each cart refresh creates a fresh disclosure, collapsed by default.
if (!customElements.get('glassify-cart-summary')) {
  customElements.define('glassify-cart-summary', class extends HTMLElement {
    connectedCallback() {
      this.sidebar = this.closest('#site-cart-sidebar');
      this.toggle = this.querySelector('.gc-summary-toggle');
      if (!this.sidebar || !this.toggle || this.onToggle) return;
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.classList.add('gc-summary-ready');
      this.onToggle = () => {
        const open = this.toggle.getAttribute('aria-expanded') !== 'true';
        this.toggle.setAttribute('aria-expanded', String(open));
        this.classList.toggle('is-open', open);
      };
      this.toggle.addEventListener('click', this.onToggle);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggle);
      this.classList.remove('gc-summary-ready');
      this.onToggle = null;
    }
  });
}

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch("?section_id=sidebar-drawer")
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser().parseFromString(
          text,
          "text/html"
        );
        const cartFormInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
        const cartSubtotalInnerHTML =
          sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

        const cartItems = document.getElementById("AjaxCartForm");
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();
        cartItems.setupCartBundleEventListeners();
        cartItems.setupSubscriptionProductListener();

        const mainProductCount = cartItems.querySelectorAll('.primary-item, [data-is-main-product="true"]').length;
        document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
          elm.textContent = mainProductCount;
        });
        document.querySelectorAll("[data-header-cart-total").forEach((elm) => {
          elm.textContent =
            cartItems.querySelector("[data-cart-total]").textContent;
        });

        document.getElementById("AjaxCartSubtotal").innerHTML =
          cartSubtotalInnerHTML;
        
        const subscriptionProductNew = sectionInnerHTML.querySelector('#site-cart-sidebar .subscription-product');
        const subscriptionProductCurrent = document.querySelector('#site-cart-sidebar .subscription-product');
        if (subscriptionProductNew && subscriptionProductCurrent) {
          subscriptionProductCurrent.outerHTML = subscriptionProductNew.outerHTML;
        }
        
        if (document.querySelector("[data-js-site-cart-sidebar]")) {
          document.querySelector("[data-js-site-cart-sidebar]").show();
        }

        if (document.querySelector("cart-recommendations")) {
          document.querySelector("cart-recommendations").innerHTML = "";
          document
            .querySelector("cart-recommendations")
            .generateRecommendations();
        }
        
        if (typeof window.addEventListeners === 'function') {
          window.addEventListeners();
        }
        
        if (typeof window.setupSubscriptionEventListeners === 'function') {
          window.setupSubscriptionEventListeners();
        }
      });
  };
}
